var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('div',{staticClass:"item-preview-qr-item",class:{'active': _vm.configId == _vm.config.id},on:{"click":function () { return _vm.chooseType(_vm.config.id); }}},[_c('img',{staticClass:"item-preview-qr-item__img",attrs:{"src":_vm.url}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afda435","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Render/PreviewQrType.vue
// module id = 482
// module chunks = 0